"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalacticMarketplaceProgram = exports.GALACTIC_MARKETPLACE_IDL = void 0;
const anchor_1 = require("@project-serum/anchor");
const data_source_1 = require("@staratlas/data-source");
const marketplace_1 = require("./idl/marketplace");
const state_1 = require("./state");
var marketplace_2 = require("./idl/marketplace");
Object.defineProperty(exports, "GALACTIC_MARKETPLACE_IDL", { enumerable: true, get: function () { return marketplace_2.IDL; } });
let GalacticMarketplaceProgram = class GalacticMarketplaceProgram extends data_source_1.ListenProgram {
    constructor(program) {
        super(program, {
            marketVars: state_1.MarketVars,
            openOrdersCounter: state_1.OpenOrdersCounter,
            orderAccount: state_1.Order,
            registeredCurrency: state_1.RegisteredCurrency,
            feeReduction: state_1.FeeReduction,
        });
    }
    static buildProgram(programId, provider, coder) {
        return new anchor_1.Program(marketplace_1.IDL, programId, provider, coder);
    }
};
GalacticMarketplaceProgram = __decorate([
    (0, data_source_1.staticImplements)(),
    __metadata("design:paramtypes", [Object])
], GalacticMarketplaceProgram);
exports.GalacticMarketplaceProgram = GalacticMarketplaceProgram;
//# sourceMappingURL=constants.js.map